<template>
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry.id)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    width="80%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :readOnly="readOnly"
    :modelNameSingular="modelNameSingular"
  >
    <template slot="editForm">
      <Form
        ref="form"
        :entry="editableEntry"
        :extraData="extraData"
        :readOnly="readOnly"
        :isEdit="isEdit"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseEdit from "@shared_components/base_edit.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      editableEntry: null,
      formErrors: [],
      extraData: null
    };
  },
  props: {
    entry: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseEdit: BaseEdit
  },
  methods: {
    loadServerEntry: function(id) {
      // console.log("LOAD Ground", id);
      this.editableEntry = null;
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_GROUND_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            id: id
          }
        })
        .then(response => {
          this.editableEntry = response.data.accountContext.ground;
          // console.log(this.entry.addressAttributes, this.entry.addressAttributes == null, response.data.accountContext.address)
          if (this.editableEntry.addressAttributes == null) {
            this.editableEntry.addressAttributes = response.data.accountContext.address;
            // console.log(this.entry.addressAttributes);
          }
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    updateServerEntry: function(ground) {
      // console.log("Edit GROUND", ground, this.editableEntry)
      // console.log("GROUND", ground, this.editableEntry.validations, this.deepFilterEntryWithAllowedFieldsForMutation(ground, this.editableEntry.validations));
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: UPDATE_GROUND_MUTATION,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(ground, this.editableEntry.validations)
          }
        })
        .then(response => {
          var errors = response.data.updateGround.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseEdit.closeDialog();
            this.$emit("entry-updated");
            this.resetForm();
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.pageLoading = false));
    },
    updateEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.updateServerEntry(this.editableEntry)
        this.resetForm();
      }
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const LOAD_GROUND_QUERY = gql `
  query ($id: ID!) {
    accountContext {
      ground(id: $id) {
        id
        type
        typeName
        name
        area
        price
        enabled
        rentalPrice
        opportunityCost
        addressAttributes {
          id
          cityId
          city {
            id
            state {
              id
            }
          }
          postalCode
          street
          neighborhood
          number
          complement
          validations
        }
        validations
      }
      address {
        id
        postalCode
        street
        neighborhood
        number
        complement
        cityId
        validations
      }
    }
    globalContext {
      allGroundTypes {
        value
        text
      }
      allStates {
        id
        name
        shortName
      }
    }
  }
`;

const UPDATE_GROUND_MUTATION = gql `
  mutation($input: GroundUpdateInputObject!) {
    updateGround(input: $input) {
      ground {
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>